import classNames from "classnames"
import styles from "./styles.module.scss"
import CloseOutline from "~icons/eva/close-outline"

const CloseModalButton = ({
  onClick,
  disabled = false,
  className,
  testId,
}: {
  onClick: () => void
  disabled?: boolean
  className?: string
  testId?: string
}) => {
  return (
    <button
      onClick={onClick}
      className={classNames(styles.closeModalButton, className)}
      disabled={disabled}
      data-testid={testId}
    >
      <CloseOutline className={styles.closeIcon} />
    </button>
  )
}

export default CloseModalButton
